import React, { FC, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { service } from "../../../services/AxiosServices";
import validator from "validator";
import { toast } from "react-toastify";
import "../../static/css/Register.css";
const RegisterForm: FC = () => {
  const [formState, setFormState] = useState({
    values: {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
    },
    clientErrors: {} as Record<string, string>,
    serverError: null as string | null,
  });

  const navigate = useNavigate();
  const validateForm = (values: Record<string, any>) => {
    const errors: Record<string, string> = {};
    if (!values.firstname.trim()) errors.firstname = "Firstname is required.";
    if (!values.lastname.trim()) errors.lastname = "Lastname is required.";

    if (!values.email.trim()) {
      errors.email = "Email is required.";
    } else if (!validator.isEmail(values.email)) {
      errors.email = "Invalid email format.";
    }

    if (!values.password.trim()) {
      errors.password = "Password is required.";
    } else if (values.password.length < 12 || values.password.length > 128) {
      errors.password = "Password must be between 12 and 128 characters.";
    } else if (!/[A-Z]/.test(values.password)) {
      errors.password = "Password must include at least one uppercase letter.";
    } else if (!/[a-z]/.test(values.password)) {
      errors.password = "Password must include at least one lowercase letter.";
    } else if (!/\d/.test(values.password)) {
      errors.password = "Password must include at least one number.";
    } else if (
      !/[!@#?$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(values.password)
    ) {
      errors.password =
        "Password must include at least one special character (e.g., !, @, #, ?).";
    }

    return errors;
  };

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [name]: value,
      },
      clientErrors: {
        ...prev.clientErrors,
        [name]: "",
      },
      serverError: null,
    }));
  }, []);
  // Handle form submission 
  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {  
      e.preventDefault();
      const errors = validateForm(formState.values);
       // Proceed if no validation errors
      if (Object.keys(errors).length === 0) {
        try {
          const application_id = localStorage.localStorage.getItem('application')

          console.log('app',application_id)
          const requestBody = {
    
            first_name: formState.values.firstname,
            last_name: formState.values.lastname,
            email: formState.values.email,
            password: formState.values.password,
            project_id: localStorage.getItem('project_id') ,
            application_id:localStorage.getItem('application'),
            created_uploaded_by:localStorage.getItem('user')
          };
   console.log(requestBody)
          await service("/register", "post", requestBody);
          toast.success("User created successfully!", { autoClose: 2000 });
          navigate("/login");
        } catch (err: any) {
          const errorMessage =
            err.response?.data?.detail ||
            "Something went wrong. Please try again.";
          setFormState((prev) => ({ ...prev, serverError: errorMessage }));
        }
      } else {
        setFormState((prev) => ({ ...prev, clientErrors: errors }));
      }
    },
    [formState.values, navigate]
  );

  const clientErrorsArray = Object.entries(formState.clientErrors).reduce(
    (acc: string[], [field, error]) => {
      if (error) {
        acc.push(`${error}`);
      }
      return acc;
    },
    []
  );

  return (
    <>
      {formState.serverError && (
        <div className="alert alert-danger">{formState.serverError}</div>
      )}
      {clientErrorsArray.length > 0 && (
        <div className="alert alert-danger">
          <ul className="mb-0">
            {clientErrorsArray.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="formFirstName" className="form-label text-light">
            First name<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control bg-white text-dark border-secondary"
            id="formFirstName"
            name="firstname"
            value={formState.values.firstname}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="formLastName" className="form-label text-light">
            Last name<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control bg-white text-dark border-secondary"
            id="formLastName"
            name="lastname"
            value={formState.values.lastname}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="formEmail" className="form-label text-light">
            Email<span className="text-danger">*</span>
          </label>
          <input
            type="email"
            className="form-control bg-white text-dark border-secondary"
            id="formEmail"
            name="email"
            value={formState.values.email}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="formPassword" className="form-label text-light">
            Password<span className="text-danger">*</span>
          </label>
          <input
            type="password"
            className="form-control bg-white text-dark border-secondary"
            id="formPassword"
            name="password"
            value={formState.values.password}
            onChange={handleChange}
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100 mt-4"
          style={{
            backgroundColor: "#777777", 
            border: "none",
            padding: "10px",
            color: "#fff", 
          }}
        >
          Register
        </button>
      </form>
    </>
  );
};

export default RegisterForm;
